export enum CalcResultType {
    POINTS = 'points',
    PERCENTS = 'percents',
    NONE = 'none',
}

interface ParamsTestsDiapason {
    from: number | null;
    to: number | null;
    text: string | null;
}

export interface SurveyAddonTests {
    maxScoreAmount?: number;
    passingScore?: number;
    testResultLabel: string;
    passingScoreLabel: string;
    scoreLabel: string;
    testPassed?: string;
    testNotPassed?: string;
    textDiapasons: Array<ParamsTestsDiapason>;
    calcResultType: CalcResultType;
}

export const initialSurveyAddonTests: Readonly<SurveyAddonTests> = {
    testResultLabel: 'Результат теста: ',
    passingScoreLabel: 'Проходной балл',
    scoreLabel: 'баллов',
    textDiapasons: [],
    calcResultType: CalcResultType.PERCENTS,
};
